import { useCallback, useState } from 'react';
import { useClickOutside } from '../useClickOutside';
export function useDropdownMenu() {
    const [openMenuId, setOpenMenuId] = useState(null);
    const closeMenu = useCallback(() => {
        setOpenMenuId(null);
    }, []);
    const clickOutsideRef = useClickOutside(closeMenu, openMenuId !== null);
    const openMenu = useCallback((menuId) => {
        setOpenMenuId(menuId);
    }, []);
    const toggleMenu = useCallback((menuId) => {
        setOpenMenuId(current => (current === menuId ? null : menuId));
    }, []);
    const isMenuOpen = useCallback((menuId) => {
        return openMenuId === menuId;
    }, [openMenuId]);
    return {
        openMenuId,
        openMenu,
        closeMenu,
        toggleMenu,
        isMenuOpen,
        clickOutsideRef,
    };
}
